import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { cacheExchange, createClient, dedupExchange, Provider  as GraphqlProvider } from 'urql';

import {IntlProvider} from 'react-intl';
import French from './lang/fr.json';
import English from './lang/en.json';
import Vietnamese from './lang/vi.json';
import { multipartFetchExchange } from "@urql/exchange-multipart-fetch";
import { loadingExchange } from "./exchanges/loadingExchange";
import { errorExchange } from "./exchanges/errorExchange";

const locale:string = "vi";

let lang;
  if (locale === "en") {
    lang = English;
  } 
  if (locale === "fr") {
      lang = French;
  }
  if (locale === "vi") {
      lang = Vietnamese;
  }


const graphQLUrl: string = process.env.REACT_APP_GRAPHQL_URL ?? '/b2b/api/graphql'


const client = createClient({
  url: graphQLUrl,
  exchanges: [
    dedupExchange,
    cacheExchange,
    loadingExchange,
    errorExchange,
    multipartFetchExchange,
  ],
  fetchOptions: () => {
    const token = getToken()
    return {
      headers: { authorization: token ? `Bearer ${token}` : '' },

    };
  },

});


function getToken (): string|null {
  return localStorage.getItem('access_token')
}


const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <IntlProvider locale ={locale} messages={lang}>
        <BrowserRouter basename="/b2b">
          <GraphqlProvider value={client}>
            <App />
          </GraphqlProvider>
        </BrowserRouter>
        </IntlProvider>
    </Provider>
  </React.StrictMode>
);
